import { createSelector } from '@reduxjs/toolkit';
import { getImmutableCompatible } from 'src/utils/immutableUtils';

const getOrder = (state) => getImmutableCompatible(state, 'order');

export const getOrderInfo = createSelector([getOrder], (order) => order?.info);
